export default "__VITE_ASSET__971b3c84__"